import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';

export const Tab = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;

  ${mediaQuery('s')} {
    justify-content: left;
  }
`;

export const TermsExpire = styled.div`
  color: var(--cvna-color-grey-5);
  padding-top: 8px;
`;

export const ExpirationDate = styled.p`
  color: var(--cvna-color-blue-6);
  font-weight: 700;
  display: inline;
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 0;
  margin-right: 8px;
  text-transform: uppercase;
  color: var(--cvna-color-blue-6);

  &.coSignerTitle {
    grid-area: coSignerTitle;
    margin: 0;
    width: fit-content;
    margin-right: 7px;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 40px;

  .coSignerTitle {
    grid-area: coSignerTitle;
  }

  &:not(:first-of-type) {
    margin-top: 2em;
  }

  &.financingTab {
    margin-right: 32px;
    margin-left: 32px;
    padding: 0;

    button {
      padding: 0;
    }
  }

  &.addCoApplicant {
    flex-direction: column;
    align-items: baseline;
    margin-bottom: 1.5em;

    ${mediaQuery('m')} {
      flex-direction: row;
    }
  }

  &.toggleCoApplicant {
    margin-bottom: 1.5em;
    display: grid;
    grid-template-columns: 75% 25%;
    grid-template-rows: auto;
    grid-template-areas:
      'coSignerTitle coApplicantToggle'
      'nameText coApplicantToggle'
      'ctaButton .';

    label {
      width: max-content;
      justify-self: end;
    }

    ${mediaQuery('m')} {
      grid-template-columns: auto auto auto 1fr;
      grid-template-areas: 'coSignerTitle nameText coApplicantToggle ctaButton';

      button {
        justify-self: end;
      }
    }
  }
`;

export const Divider = styled.div`
  align-self: center;
  width: 90%;
  padding: 1em 0em;
  border-bottom: 1px solid var(--cvna-color-grey-2);
`;

export const FaqLink = styled.a`
  color: var(--cvna-color-blue-2);
  font-size: 16px;

  ${mediaQuery('s')} {
    :hover {
      text-decoration: underline;
      color: var(--cvna-color-blue-6);
    }
  }
`;

export const FaqContainer = styled.div`
  margin: 2.5rem 0;
  align-self: center;
  text-align: center;
`;
